import { useState } from 'react'
import Layout from 'src/components/Layout'
import { getAllVerticals, getPage } from 'src/utils/contentful'
import Head from 'next/head'
import Script from 'next/script'

import { useAwsUser } from 'src/utils/useAwsUser'
import ValueProposal from 'src/components/Affiliate/ValueProposal'
import RxHero from 'src/components/Rx/Hero'
import AffiliateFAQ from 'src/components/Home/FAQs'
import RxInsurersParade from 'src/components/Rx/InsurersParade'
import IntroSection from 'src/components/Rx/Intro'
import CTASection from 'src/components/Rx/CTASection'
import RxFaq from 'src/components/Rx/FaqList'
import RxModal from 'src/components/Rx/Modal'

const RxPage = ({ verticals, vertical, page }) => {
  const verticalSlug = vertical?.slug?.replace('-insurance', '')
  const [user] = useAwsUser(null)
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <Layout
      verticals={verticals}
      // vertical={vertical}
      seo={{ title: 'Rx Discount Card' }}
      footer={{ noBorder: true, rx: true }}
    >
      <main>
        <RxHero
          verticalSlug={verticalSlug}
          hero={vertical.hero}
          shortDescription={vertical.shortDescription}
          title={vertical.title}
          user={user}
          setIsModalOpen={setIsModalOpen}
        />

        <RxInsurersParade />

        <IntroSection user={user} setIsModalOpen={setIsModalOpen} />

        <RxFaq />

        <ValueProposal />

        <CTASection />

        <AffiliateFAQ faqList={page.faqList} />
        <Script key={`jornayascript`} id="LeadiDscript" type="text/javascript">
          {`
                        (function() {
                        var s = document.createElement('script');
                        s.id = 'LeadiDscript_campaign';
                        s.type = 'text/javascript';
                        s.async = true;
                        s.src = '//create.lidstatic.com/campaign/f9212193-4afd-a49a-83a4-b38cd5943d4b.js?snippet_version=2';
                        var LeadiDscript = document.getElementById('LeadiDscript');
                        LeadiDscript.parentNode.insertBefore(s, LeadiDscript);
                        })();
                    `}
        </Script>
        <Head>
          <noscript
            key={`jornayanoscript`}
          >{`<img src='//create.leadid.com/noscript.gif?lac=175deec7-46ac-376d-3c9f-2e7d7b607660&lck=f9212193-4afd-a49a-83a4-b38cd5943d4b&snippet_version=2' />`}</noscript>
        </Head>
      </main>
      <RxModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
    </Layout>
  )
}

export default RxPage

export async function getStaticProps() {
  // const vertical = await getVertical(params.vertical)
  const page = await getPage('identity')
  const verticals = await getAllVerticals()
  const vertical = {
    slug: 'rx',
    title: 'Rx Discount Card - Claim',
    icon: 'rx',
    hero: {
      photo: {
        url: '/images/identity.png',
      },
    },
    image: '/images/identity.png',
  }

  return { props: { verticals, vertical, page } }
}
